import Avatar from '@mui/material/Avatar'
import { reExportedColors } from '../index'

const AvatarBase = ({ className, children }) => (
  <Avatar
    className={className}
    sx={(theme) => ({
      backgroundColor: theme.palette.secondary.accent,
      height: 79,
      width: 79,
      '& p': { color: reExportedColors.WHITE }
    })}
  >
    {children}
  </Avatar>
)

export default AvatarBase
